// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleScimIdentityManager = {
  id: "scim-identity-manager",
  mrn: "//iam.api.mondoo.app/roles/scim-identity-manager",
  title: "SCIM Identity Manager",
  allowedActions,
} as const;

export type RoleScimIdentityManager = typeof roleScimIdentityManager;
